import { ItemBoxDto } from '@marketplace-web/item-box/product-item-data'

import { ItemThumbnailSize } from '../constants/close-promotions'
import { UserPhotoDto } from './user-photo'
import { CurrencyAmountDto } from './currency'

export enum SortByOption {
  Relevance = 'relevance',
  PriceHighToLow = 'price_high_to_low',
  PriceLowToHigh = 'price_low_to_high',
  NewestFirst = 'newest_first',
}

export type CatalogFilterParams = {
  filters: {
    search_text?: string
    catalog_ids?: string
    price_from?: string
    price_to?: string
    currency?: string
    order?: SortByOption
    disable_search_saving?: boolean
  }
  dynamicFilters: Record<string, string>
}

export type GetClosetPromotionArgs = {
  page?: number
  perPage?: number
  excludedUserIds?: Array<number | string> | null
  searchSessionId?: string | null
  screenName?: string
  isPreview?: boolean
  catalogFilterParams?: CatalogFilterParams
}

export type ClosetUserModel = {
  id: number
  name: string
  image: string | null
  rating: number
  ratingCount: number
  isFollowed: boolean
  itemCount: number
}

export type ClosetModel = {
  user: ClosetUserModel
  items: Array<ClosetPromotionItemDto>
  showBanner: boolean
  isPreview?: boolean
}

type ClosetPromotionItemPhotoThumbnailDto = {
  type: ItemThumbnailSize | string
  url: string
}

export type ClosetPromotionItemPhotoDto = {
  id: number
  url: string
  dominant_color_opaque: string
  thumbnails: Array<ClosetPromotionItemPhotoThumbnailDto>
  image_no: number
  is_main: boolean
  orientation?: number | null
}

export type ClosetPromotionUserDto = {
  id: number
  login: string
  photo: UserPhotoDto | null
  is_favourite: boolean
  item_count: number
  feedback_reputation: number
  feedback_count: number
}

export type ClosetPromotionItemDto = {
  id: number
  title: string
  user_id: number
  favourite_count: number
  is_favourite: boolean
  url: string
  photo: ClosetPromotionItemPhotoDto
  photos: Array<ClosetPromotionItemPhotoDto> | null
  price: CurrencyAmountDto
  service_fee?: CurrencyAmountDto | null
  total_item_price?: CurrencyAmountDto
  business_user?: boolean
  item_box?: ItemBoxDto | null
}

export type ClosetDto = {
  user: ClosetPromotionUserDto
  items: Array<ClosetPromotionItemDto>
}

export type PromotedClosetsListResp = {
  promoted_closets: Array<ClosetDto>
  page_info: {
    has_more: boolean
  }
}
